module.exports = __webpack_public_path__ + "static/media/flightLog.9bf57dda.png";